<template>
  <div>
    <data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="row-pointer"
    >
      <template v-slot:top>
        <v-toolbar
            flat
            class="grey lighten-3"
        >
          <v-spacer></v-spacer>
          <v-btn
              icon
              @click="dialog = true"
              title="Dodaj nową notatkę."
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
              icon
              @click="load"
              title="Odśwież listę."
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-dialog
              v-model="dialog"
              max-width="500px"
          >
            <v-card>
              <v-card-title>
              <span class="headline">
                {{ formTitle }}
              </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                    >
                      <v-textarea
                          v-model="editedItem.note"
                          label="Notatka"
                          :rows="getRowCount(editedItem)"
                          :rules="rules.note"
                          aria-valuemin="3"
                          counter="65535"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="onCloseDialogBtn"
                >
                  Anuluj
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="onSaveDialogBtn"
                >
                  Zapisz
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">
                Czy na pewno chcesz usunąć tę notatkę?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="onDeleteDialogClosed">
                  Anuluj
                </v-btn>
                <v-btn color="blue darken-1" text @click="onDeleteConfirmed">
                  Tak
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.note="{ item }">
        <v-textarea
            :rows="getRowCount(item)"
            v-model="item.note"
            :readonly="true"
            :rules="rules.note"
            aria-valuemin="3"
            counter="65535"
        ></v-textarea>
      </template>
      <template v-slot:item.author="{ item }"
                class="text-end"
      >
        {{ getAuthorDetails(item.author) }}
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ localDateTime(item.createdAtDto) }}
      </template>
      <template v-slot:item.actions="{ item }"
                class="text-end"
      >
        <v-icon
            class="mx-2"
            :disabled="saving"
            @click="editItem(item)"
            title="Zapisz notatkę."
        >
          mdi-pencil
        </v-icon>
        <v-icon
            class="mx-2"
            :disabled="saving"
            @click="deleteItem(item)"
            title="Usuń notatkę."
        >
          mdi-delete
        </v-icon>
      </template>
    </data-table>
    <v-toolbar
        flat
        class="grey lighten-3"
    >
      <v-spacer></v-spacer>
      <v-btn
          icon
          @click="dialog = true"
          title="Dodaj nową notatkę."
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn
          icon
          @click="load"
          title="Odśwież listę."
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import api from "@/services/api";
import DataTable from "@/components/data-table/DataTable";
import {getDatatableParams, setDatatableOptions} from "@/utils/helpers";
import formatters from "@/mixins/formatters";

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    urlAdd: {
      type: [String],
      required: true,
    },
    urlDelete: {
      type: [String],
      required: true,
    },
    urlUpdate: {
      type: [String],
      required: true,
    },
    urlList: {
      type: [String],
      required: true,
    },
  },
  mixins: [
    formatters,
  ],
  components: {
    DataTable,
  },
  data() {
    return {
      loading: false,
      saving: false,
      items: [],
      total: 0,
      options: {},
      headers: [
        {text: 'Notatka', value: 'note', sortable: false},
        {text: 'Autor', value: 'author', sortable: false},
        {text: 'Dodano', value: 'createdAt', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      rules: {
        note: [
          (value) => {
            return String(value).length >= 3 || 'Notatka musi mieć przynajmniej 3 znaki.';
          },
        ],
      },

      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {
        note: '',
      },
      defaultItem: {
        id: 0,
        note: '',
        author: {
          id: null,
          name: '',
          surname: '',
        },
        createdAt: '',
      },
    };
  },
  computed: {
    formTitle() {
      return -1 === this.editedIndex ? 'Nowa notatka' : 'Edycja notatki'
    },
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
    dialog(value) {
      value || this.onCloseDialogBtn();
    },
    dialogDelete(value) {
      value || this.onDeleteDialogClosed();
    },
  },
  methods: {
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get(this.$props.urlList.replace('{parentId}', this.id), {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać listy notatek.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getAuthorDetails(author) {
      return String(`${author.name || ''} ${author.surname || ''} #${author.id}`).trim();
    },
    getRowCount(item) {
      if (!item.note) {
        return 1;
      }

      const note = String(item.note);
      const lines = note.split(/\r?\n/, 11);

      return lines.length < 10 ? lines.length : 10;
    },
    add(item) {
      if (this.saving) {
        return;
      }

      this.saving = true;

      api.post(this.$props.urlAdd.replace('{parentId}', this.id), {note: item.note})
          .then((response) => {
            this.refreshItem(item, response.data);
            this.addSavedItem(item);
            this.$root.$emit('notifySuccess', {
              html: `Notatka została zapisana.`,
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się dodać notatki.',
              error,
            });
          })
          .finally(() => {
            this.saving = false;
          });
    },
    delete(index) {
      if (this.saving) {
        return;
      }

      this.saving = true;
      const item = this.items[index];

      api
          .delete(
              this.$props.urlDelete.replace('{parentId}', this.id).replace('{id}', item.id)
          )
          .then(() => {
            this.items.splice(index, 1);
            this.total--;

            if (!this.items.length) {
              this.options.page--;
            }

            this.onDeleteDialogClosed();
            this.$root.$emit('notifySuccess', {
              html: `Notatka została usunięta.`,
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się usunąć notatki.',
              error,
            });
          })
          .finally(() => {
            this.saving = false;
          });
    },
    update(item, newData) {
      if (this.saving) {
        return;
      }

      this.saving = true;

      api
          .put(
              this.$props.urlUpdate.replace('{parentId}', this.id).replace('{id}', item.id),
              newData
          )
          .then((response) => {
            this.refreshItem(item, response.data);
            this.$root.$emit('notifySuccess', {
              html: `Notatka została zapisana.`,
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się zmodyfikować notatki.',
              error,
            });
          })
          .finally(() => {
            this.saving = false;
          });
    },
    refreshItem(item, newData) {
      item.id = newData.id;
      item.note = newData.note;
      item.author.id = newData.author.id;
      item.author.name = newData.author.name;
      item.author.surname = newData.author.surname;
      item.createdAt = newData.createdAt;
      item.createdAtDto = newData.createdAtDto;
    },
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }
    },
    addSavedItem(item) {
      const previousCount = this.items.length;
      this.items.push(item);
      this.total++;

      if (previousCount >= this.options.itemsPerPage) {
        this.options.page++;
      }
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    onDeleteConfirmed() {
      this.delete(this.editedIndex);
    },
    onSaveDialogBtn() {
      if (this.editedIndex > -1) {
        this.update(
            this.items[this.editedIndex],
            {
              note: this.editedItem.note,
            }
        );
      } else {
        const length = this.items.length;
        const lastItem = this.items[length - 1];
        let newItem = JSON.parse(JSON.stringify(this.defaultItem));

        newItem.id = (lastItem ? lastItem.id : 0) + 1;
        newItem.note = this.editedItem.note;
        newItem.author.id = this.$store.state.user.identity.userId;
        newItem.author.name = ''; // TODO.
        newItem.author.surname = ''; // TODO.

        this.add(newItem);
      }

      this.onCloseDialogBtn();
    },
    onCloseDialogBtn() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    onDeleteDialogClosed() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
}
</script>